import React from "react";
import "./cartWarning.css";
import closeIcon from "../../../../assets/rr310/red-x.png";
import placeholder from "../../../../assets/imgPlaceholder.png";
import { useState, useEffect } from "react";

const CartWarning = ({
  warningMessage,
  onClose,
  toastMessage,
  crossSellMessage,
  crossSellImg,
}) => {
  const [width, setWidth] = useState(0);
  useEffect(() => {
    if (toastMessage) {
      const progressDuration = 2000;
      const progressStartTime = Date.now();

      const animateProgressBar = () => {
        const currentTime = Date.now();
        const elapsedTime = currentTime - progressStartTime;
        if (elapsedTime < progressDuration) {
          const newWidth = (elapsedTime / progressDuration) * 100;

          setWidth(newWidth);
          requestAnimationFrame(animateProgressBar);
        } else {
          setWidth(100);
        }
      };

      animateProgressBar();
    }
  }, [toastMessage]);
  return (
    <div className="cartwarning_container mediumFont">
      <div className="close_button" onClick={onClose}>
        <img src={closeIcon} className="close_icon" alt="closeImg" />
      </div>
      {crossSellImg && (
        <div className="suggestion_image_container">
          <img src={crossSellImg}></img>
        </div>
      )}

      {toastMessage ? (
        <div className="toast_message">{toastMessage}</div>
      ) : crossSellMessage ? (
        <div className="description">{crossSellMessage}</div>
      ) : (
        <div className="description">{warningMessage}</div>
      )}
      {toastMessage ? (
        <div className="progress_bar_container">
          <div
            className="progress_bar"
            style={{
              width: `${width}%`,
            }}
          ></div>
        </div>
      ) : null}
      {toastMessage ? null : (
        <div className="cart_warning_button boldFont" onClick={onClose}>
          OK
        </div>
      )}
    </div>
  );
};

export default CartWarning;
